import AppInfoResourceModel from '../../generated/types/model/resource/AppInfoResourceModel';

export default class AppInfoResourceViewModel extends AppInfoResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
